import React from "react";
import DocTabs from "./DocTabs";

const DocDetails = () => {
  return (
    <div>
      <DocTabs />
    </div>
  );
};

export default DocDetails;
